module.exports = __webpack_public_path__ + "static/media/orders_120.f88df925.png";